import ArticleLayout from "@/components/feature/ArticleLayout";
import { articles } from "@/mocks/articles";

const article = articles[8];

export default function Artigo() {
  return (
    <ArticleLayout
      title={article.title}
      description={article.excerpt}
      date={article.date}
      readTime={article.readTime}
      imageUrl={article.imageUrl}
      keywords="CSSBuy frete, custos envio CSSBuy, frete China Portugal, CSSBuy shipping, métodos envio"
      articleSchemaName="CSSBuy Spreadsheet"
      faqItems={article.faq}
    >
      <p>
        Uma das maiores dúvidas de quem usa o CSSBuy é sobre os custos de frete. Neste artigo, explicamos todos os métodos de envio disponíveis, preços de referência e como poupar no frete para Portugal e Brasil.
      </p>

      <h2>Métodos de Envio CSSBuy</h2>
      <p>
        O CSSBuy oferece vários métodos de envio internacional:
      </p>
      <ul>
        <li><strong>EUB (ePacket)</strong>: económico, 15-30 dias, ideal para pacotes pequenos</li>
        <li><strong>EMS</strong>: equilíbrio entre preço e velocidade, 7-15 dias</li>
        <li><strong>DHL/FedEx</strong>: rápido, 3-7 dias, mais caro</li>
        <li><strong>SAL</strong>: muito económico mas extremamente lento, 30-60 dias</li>
        <li><strong>China Post Air Mail</strong>: económico, 20-40 dias</li>
      </ul>

      <h2>Tabela de Preços de Referência</h2>
      <p>
        Preços estimados para envio para Portugal (valores aproximados em 2026):
      </p>
      <ul>
        <li>Pacote 0.5kg: €12-18 (EUB), €22-30 (DHL)</li>
        <li>Pacote 1kg: €18-25 (EUB), €28-38 (DHL)</li>
        <li>Pacote 2kg: €28-40 (EUB), €40-55 (DHL)</li>
        <li>Pacote 5kg: €55-80 (EMS), €80-110 (DHL)</li>
      </ul>

      <h2>Dicas para Poupar no Frete</h2>
      <p>
        As melhores estratégias para reduzir custos de envio:
      </p>
      <ul>
        <li>Agrupa vários produtos num só envio (consolidação)</li>
        <li>Remove caixas de sapatos (salva 200-400g por par)</li>
        <li>Escolhe EUB para pacotes abaixo de 2kg</li>
        <li>Usa rehearsal packaging (embalagem simulada) para saber o peso exato antes de pagar o frete</li>
        <li>Aproveita promoções sazonais do CSSBuy no frete</li>
      </ul>

      <h2>Calculadora de Frete CSSBuy</h2>
      <p>
        O CSSBuy tem uma calculadora de frete integrada que mostra o custo estimado antes de finalizares a compra. Recomendamos usar sempre esta ferramenta para planear o orçamento. Para encontrar os melhores produtos com bom custo-benefício, usa a <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow">nossa planilha CSSBuy</a>.
      </p>
    </ArticleLayout>
  );
}